/**
 * @module
 * @description Base vendor module for the core theme libs js.
 */

import embeds from './embeds'
import forms from './forms'
import searchform from './searchform'
import socialShare from './social-share'
import smoothAnchors from 'utils/dom/smooth-anchors'
import skipLinkTop from './skip-link-top'

/**
 * @function init
 * @description Kick off this modules functions
 */

const init = () => {
	embeds()
	forms()
	searchform()
	socialShare()
	smoothAnchors()
	skipLinkTop()
}

export default init
